import { useState } from 'react'

export function useUniqueDef() {
  const [id] = useState(() => `ref-${Math.random()}`.replace('.', ''))
  const url = `url(#${id})`
  return { id, url }
}
